module.exports = __webpack_public_path__ + "assets/img/s3-tab-3-8a727bb4.png";